var _desc, _defs, _rect, _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStorefrontEnergyDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Energy drink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A tall energy drink can product illustration.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "energy-can",
    x1: 70,
    y1: 30,
    x2: 170,
    y2: 218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f2937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#91011e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b23212"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 24,
    fill: "#fff7f5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 39,
    rx: 42,
    ry: 15,
    fill: "#e5e7eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h84v158c0 12.7-18.8 23-42 23s-42-10.3-42-23V39Z",
    fill: "url(#energy-can)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 197,
    rx: 42,
    ry: 23,
    fill: "#6f0017"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 39,
    rx: 42,
    ry: 15,
    fill: "#f3f4f6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 41,
    rx: 27,
    ry: 7,
    fill: "#9ca3af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 63 99 126h23l-10 52 31-70h-24l9-45Z",
    fill: "#f6a33c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85h52M94 156h52",
    fill: "none",
    stroke: "#fff7f5",
    strokeWidth: 6,
    strokeLinecap: "round",
    opacity: 0.84
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53c14 7 45 8 62 0",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStorefrontEnergyDrink);
export default __webpack_public_path__ + "static/media/product_storefront_energy_drink.45cd86044ffe580fe6455f8bc376567f.svg";
export { ForwardRef as ReactComponent };